<template>
  <PageTemplate>
    <v-sheet
      class="
        error404-page
        transparent
        d-flex
        flex-column
        justify-center
        align-center
        px-4
        pb-10 pb-sm-16
      "
    >
      <img src="/img/error-404.svg" />
      <div class="text-h6 text-sm-h5 font-weight-bold mt-10 text-center">
        Página não encontrada
      </div>
    </v-sheet>
  </PageTemplate>
</template>

<script>
import PageTemplate from "../../templates/Page.vue";

export default {
  components: {
    PageTemplate,
  },
};
</script>

<style>
.error404-page img {
  max-width: 500px;
}
</style>
